var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelopIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("span", {
  className: "icon"
}, /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  fill: "none",
  viewBox: "0 0 22 23",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.085 2.708H2.915A2.7 2.7 0 0 0 .22 5.402v11.55a2.7 2.7 0 0 0 2.695 2.695h16.17a2.7 2.7 0 0 0 2.695-2.694V5.403a2.7 2.7 0 0 0-2.695-2.695m-.682 4.457-6.93 5.39a.77.77 0 0 1-.945 0l-6.93-5.39a.771.771 0 1 1 .945-1.215L11 10.972l6.458-5.022a.77.77 0 0 1 .945 1.215"
}))));
export { SvgEnvelopIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/envelopIcon.svg";